import React, { useEffect, useRef } from "react";
import { TestQuestionAnswer } from "./TestQuestionAnswer";
import { modifyMediaUrl } from "../helpers/modifyMediaUrl";

export const QUESTION_GROUP_TYPE_CODE = {
  LISTENING: "LISTENING",
  READING: "READING",
  WRITING: "WRITING",
};

export const TestQuestionGroup = ({ questionGroupData, questionIndex = 0, handleChangeAnswer = () => {}, testAnswers }) => {
  const question = questionGroupData?.questions?.[questionIndex];
  const audioRef = useRef(null);

  const getQuestionAnswerById = (id) => {
    return testAnswers.find((item) => item.questionId === id) || null;
  };

  // Question title (the API `title` field, e.g. "# 다음을 읽고 …"). Per Figma
  // (node 2250:11918 / 2453:3770) it is a bare line above, Roboto 18, for EVERY
  // question type — NOT inside the box. (`instruction` is a legacy fallback.)
  const title = question?.title || questionGroupData?.title || question?.instruction || questionGroupData?.instruction;

  // The blue callout box holds the question body/passage (`content`, HTML). It is
  // shown only when there is real (non-tag) content — image/word questions with no
  // body get just the title + image (Figma 2453:3763).
  const contentHtml = question?.content || "";
  const hasContent = contentHtml.replace(/<[^>]*>/g, "").trim().length > 0;

  // Reset the audio element when moving to another question.
  useEffect(() => {
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
      audioRef.current.load();
    }
  }, [questionGroupData, questionIndex]);

  return (
    <div className="pretest-question">
      {/* Question title (bare line above, all question types). */}
      {title && <p className="pretest-question__instruction">{title}</p>}

      {/* Blue body/passage box — only when there is real content. */}
      {hasContent && <div className="pretest-question__callout keduall-typography" dangerouslySetInnerHTML={{ __html: contentHtml }} />}

      {question?.audioUrl && (
        <div className="pretest-audio-wrap">
          <audio ref={audioRef} controls preload="metadata" className="pretest-audio-native">
            <source src={modifyMediaUrl(question.audioUrl)} type="audio/mp3" />
            <source src={modifyMediaUrl(question.audioUrl)} type="audio/ogg" />
            <source src={modifyMediaUrl(question.audioUrl)} type="audio/wav" />
          </audio>
        </div>
      )}

      {question?.imageUrl && (
        <div className="pretest-question__image">
          <img src={modifyMediaUrl(question.imageUrl)} alt="question" className="max-w-full" />
        </div>
      )}

      <TestQuestionAnswer handleChangeAnswer={handleChangeAnswer} question={question} userQuestionAnswer={getQuestionAnswerById(question?.id)} />
    </div>
  );
};
